{
  "rtl": true,

  "search": "البحث",
  "search_no_results_1": "أوه لا!",
  "search_no_results_2": "لا يمكن العثور على هذا الرمز التعبيري",
  "pick": "اختر رمزًا تعبيريًا…",
  "add_custom": "أضف رمزًا تعبيري مخصص",
  "categories": {
    "activity": "نشاط",
    "custom": "مخصص",
    "flags": "أعلام",
    "foods": "طعام & شراب",
    "frequent": "تم أستخدامه مؤخرا",
    "nature": "الحيوانات & الطبيعة",
    "objects": "أجسام",
    "people": "وجوه ضاحكه & اشخاص",
    "places": "السفر & الأماكن",
    "search": "نتائج البحث",
    "symbols": "حرف او رمز"
  },
  "skins": {
    "choose": "اختر لون البشرة الافتراضي",
    "1": "إفتراضي",
    "2": "فاتح",
    "3": "فاتح متوسط",
    "4": "متوسط",
    "5": "داكن متوسط",
    "6": "داكن"
  }
}
